import React from 'react';
import './Message.css';

const Message = () => {
  return (
    <div className='message'>
      <p>You're a true Jedi!</p>
    </div>
  );
};

export default Message;
